export const normalizeGiftCode = (value = "") => value.replace(/\s+/g, "").toUpperCase();
